import React from "react";
// import "./App.css";
import '../styles/HomeStyles.css'
const Header = () => (
  <header className="default-header">
    <div className="container-fluid">
      <div className="header-wrap">
        <div className="header-top d-flex justify-content-between align-items-center">
          <div className="logo">
            <a href="index.html">
              <img src="img/logo.svg" alt="logo" />
            </a>
          </div>
          <div className="main-menubar d-flex align-items-center">
            <nav className="hide">
              <a href="index.html">Home</a>
              <a href="generic.html">Sign In</a>
              <a href="elements.html">FREE DEMO</a>
            </nav>
            <div className="menu-bar">
              <span className="lnr lnr-menu"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
);

const Banner = () => (
  <section className="banner-area relative">
    <div className="container">
      <div className="row fullscreen align-items-center justify-content-center">
        <div className="banner-left col-lg-6">
          <img className="d-flex mx-auto img-fluid" src="img/header-img.png" alt="" />
        </div>
        <div className="col-lg-6">
          <div className="story-content">
            <h6 className="text-uppercase">FOR RESTAURANTS AND HOTELS</h6>
            <h1>
              Behind Every <span className="sp-1">Menu</span>
              <br /> There is <span className="sp-2">ZAFFLO</span>
            </h1>
            <a href="#" className="genric-btn primary circle arrow">
              Free Demo<span className="lnr lnr-arrow-right"></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const AboutUs = () => (
  <section className="about-area pt-100 pb-100">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-lg-6">
          <div className="story-content">
            <h2>
              Brief Information <br /> About <span>Us :</span>
            </h2>
            <p className="mt-30">
              We are a smart digital solution for restaurants and hotels. We provide an
              interactive digital menu that allows customers to browse, order, and enjoy a seamless
              dining experience. Elevate your service with our innovative digital menu system today!
            </p>
            <a href="#" className="genric-btn primary-border circle arrow">
              Free Demo<span className="lnr lnr-arrow-right"></span>
            </a>
          </div>
        </div>
        <div className="col-lg-6">
          <img className="img-fluid d-flex mx-auto" src="img/about.png" alt="about" />
        </div>
      </div>
    </div>
  </section>
);

const Footer = () => (
  <footer className="section-gap">
    <div className="container">
      <div className="footer-bottom d-flex justify-content-between align-items-center flex-wrap">
        <p className="footer-text m-0">
          Copyright &copy; {new Date().getFullYear()} All rights reserved | Made with
          <i className="fa fa-heart-o" aria-hidden="true"></i> by
          <a href="https://zafflo.com" target="_blank" rel="noopener noreferrer">
            ZAFFLO
          </a>
        </p>
      </div>
    </div>
  </footer>
);

const HomePage = () => {
  return (
    <div className="oz-body-wrap">
      <Header />
      <Banner />
      <AboutUs />
      <Footer />
    </div>
  );
};

export default HomePage;
